'use client';

import { c as _c } from "react/compiler-runtime";
import SettingConfig from '@module/config/setting';
import { cn } from '@module/lib/utils';
import useModalStore from '@module/stores/useModalStore';
import { useEffect } from 'react';
interface Props {
  children: React.ReactNode;
  isClosableOnBackgroundClick?: boolean;
  overlayClassName?: string;
  contentClassName?: string;
  onClose?: () => void;
  backDrop?: boolean;
  isCloseButton?: boolean;
  isClosableOnEscClick?: boolean;
}
function ModalOverlay(t0) {
  const $ = _c(26);
  const {
    children,
    overlayClassName,
    contentClassName,
    onClose,
    isClosableOnBackgroundClick: t1,
    backDrop: t2,
    isCloseButton: t3,
    isClosableOnEscClick: t4
  } = t0;
  const isClosableOnBackgroundClick = t1 === undefined ? true : t1;
  const backDrop = t2 === undefined ? true : t2;
  const isCloseButton = t3 === undefined ? false : t3;
  const isClosableOnEscClick = t4 === undefined ? false : t4;
  const popModal = useModalStore(_temp);
  let t5;
  if ($[0] !== isClosableOnBackgroundClick || $[1] !== onClose || $[2] !== popModal) {
    t5 = () => {
      if (!isClosableOnBackgroundClick) {
        return;
      }
      if (onClose) {
        onClose();
      }
      popModal();
    };
    $[0] = isClosableOnBackgroundClick;
    $[1] = onClose;
    $[2] = popModal;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const handleOverlayClick = t5;
  let t6;
  if ($[4] !== popModal) {
    t6 = event => {
      if (event.key === "Escape") {
        popModal();
      }
    };
    $[4] = popModal;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const handleEsc = t6;
  let t7;
  if ($[6] !== handleEsc || $[7] !== isClosableOnEscClick) {
    t7 = () => {
      if (!isClosableOnEscClick) {
        return;
      }
      document.addEventListener("keydown", handleEsc);
      return () => {
        document.removeEventListener("keydown", handleEsc);
      };
    };
    $[6] = handleEsc;
    $[7] = isClosableOnEscClick;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [];
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  useEffect(t7, t8);
  let t9;
  if ($[10] !== backDrop || $[11] !== overlayClassName) {
    t9 = cn("pointer-events-auto fixed top-0 left-0 z-40 h-full w-full overflow-x-auto", {
      "bg-black/30": backDrop
    }, overlayClassName);
    $[10] = backDrop;
    $[11] = overlayClassName;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== isCloseButton || $[14] !== popModal) {
    t10 = isCloseButton && <button type="button" className="absolute top-2 right-2 z-[100]" onClick={e => {
      e.stopPropagation();
      popModal();
    }}><img src={`${SettingConfig.S3_BUCKET_URL}/img/icon/x_circle.png`} alt="close" /></button>;
    $[13] = isCloseButton;
    $[14] = popModal;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== contentClassName) {
    t11 = cn("-translate-x-1/2 -translate-y-1/2 absolute top-1/2 left-1/2 z-50", contentClassName);
    $[16] = contentClassName;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== children || $[19] !== t11) {
    t12 = <div className={t11} onClick={_temp2}>{children}</div>;
    $[18] = children;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== handleOverlayClick || $[22] !== t10 || $[23] !== t12 || $[24] !== t9) {
    t13 = <div role="dialog" className={t9} onClick={handleOverlayClick}>{t10}{t12}</div>;
    $[21] = handleOverlayClick;
    $[22] = t10;
    $[23] = t12;
    $[24] = t9;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  return t13;
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}
function _temp(state) {
  return state.popModal;
}
export default ModalOverlay;